export class Blog
{
	blogId: number;
	blogDate: Date;
	pictures: any[];
	statementMonth: Date;
	blogDevelopmentAPIList: any[];
	type: number;
	name: string;
	description: string;
	status: string;
	keywordsForSeo: string;
	leadDescription: string;
}
